export enum EnaioWarningType {
    objectDefinition = 0,
    dbInconsistencyHistoryCorrupt = 1,
    dbInconsistencyHistoryMissing = 2,
    dbInconsistencyOswffieldvalsCorrupt = 3,
    dbInconsistencyWfTrayCorrupt = 4,
    dbInconsistencySdrelCorrupt = 5,
    dbInconsistencyInvalidObjectId = 6,
    scriptVba = 7
}
export namespace EnaioWarningType{
    export function getName(value: EnaioWarningType): string {
        switch (value) {
            case EnaioWarningType.objectDefinition:
                return "objectDefinition";
            case EnaioWarningType.dbInconsistencyHistoryCorrupt:
                return "dbInconsistencyHistoryCorrupt";
            case EnaioWarningType.dbInconsistencyHistoryMissing:
                return "dbInconsistencyHistoryMissing";
            case EnaioWarningType.dbInconsistencyOswffieldvalsCorrupt:
                return "dbInconsistencyOswffieldvalsCorrupt";
            case EnaioWarningType.dbInconsistencyWfTrayCorrupt:
                return "dbInconsistencyWfTrayCorrupt";
            case EnaioWarningType.dbInconsistencySdrelCorrupt:
                return "dbInconsistencySdrelCorrupt";
            case EnaioWarningType.dbInconsistencyInvalidObjectId:
                return "dbInconsistencyInvalidObjectId";
            case EnaioWarningType.scriptVba:
                return "scriptVba";
        }
    }
}
